<template>
  <div class="productDetail">
    <pageDetail :dataObj="dataObj" :actNum="actNum" />
  </div>
</template>

<script>
import pageDetail from "./index.vue";
import { data1, data2, data3, data4, data5 } from "./config/productConfig";
export default {
  name: "productDetail",
  components: {
    pageDetail,
  },
  data() {
    return {
      dataObj: null,
      actNum:null
    };
  },
  created() {
    this.actNum = Number(this.$route.query.num)
    if (this.$route.query.type == "1") {
      this.dataObj = data1;
    } else if (this.$route.query.type == "2") {
      this.dataObj = data2;
    } else if (this.$route.query.type == "3") {
      this.dataObj = data3;
    } else if (this.$route.query.type == "4") {
      this.dataObj = data4;
    } else if (this.$route.query.type == "5") {
      this.dataObj = data5;
    }
  },
};
</script>

<style>
</style>